<mat-form-field [ngClass]="formFieldClass" class="fc-datepicker">
  <mat-label>
    {{ label }}
    @if (tooltip !== null) {
      <fa-icon
        #tooltip="matTooltip"
        (click)="tooltip.toggle()"
        [icon]="['far', 'circle-info']"
        class="blue"
        [matTooltip]="getTooltip()"
        matTooltipClass="fc-tooltip"
      matTooltipPosition="right"></fa-icon>
    }
  </mat-label>
  <input
    #dateInput
    (blur)="onBlur()"
    [(ngModel)]="formattedDate"
    [class]="inputClass"
    [errorStateMatcher]="errorMatcher"
    [id]="inputID"
    dateMask
    matInput
    [required]="required"
    placeholder="MM/DD/YYYY"
    type="text" />
  <input
    (dateChange)="onDateChange($event)"
    (ngModelChange)="onChange($event)"
    [(ngModel)]="value"
    [matDatepickerFilter]="datepickerFilter"
    [matDatepicker]="picker"
    [max]="maxDate"
    [min]="minDate"
    hidden
    class="hidden"
    matInput
    placeholder="MM/DD/YYYY" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
@if (ngControl.touched) {
  @if (invalid || invalidDate || ngControl.hasError('required')) {
    <mat-error [id]="inputID + 'ValidError'">
      A valid date is
      <b>required</b>
      .
    </mat-error>
  }
  @if (minDate && value && value < minDate) {
    <mat-error [id]="inputID + 'MinError'">
      This date
      <b>precedes</b>
      the minimum allowed date:
      <b>{{ minDate | date: 'shortDate' }}</b>
    </mat-error>
  }
  @if (maxDate && value && value > maxDate) {
    <mat-error [id]="inputID + 'MaxError'">
      This date
      <b>exceeds</b>
      the maximum allowed date:
      <b>{{ maxDate | date: 'shortDate' }}</b>
    </mat-error>
  }
  @if (value && datepickerFilter && !datepickerFilter(value)) {
    <mat-error
      [id]="inputID + 'FilterError'"
    [innerHtml]="dateFilterErrorMessage ? dateFilterErrorMessage : 'This date is not permitted.'"></mat-error>
  }
}
